module.exports = __webpack_public_path__ + "static/verify-email-admin-view-be74e6fb3b32aadacb1455daea5d0225.png";